import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StoreAddress from '../entities/back-storeaddress-list'
import appconst from '@/lib/appconst';


interface StoreAddressState extends ListState<StoreAddress> {
    total: any;
    StoreAddressInfo: StoreAddress,
}

class StoreAddressMutations extends ListMutations<StoreAddress>{

}
class StoreAddressInfo extends ListModule<StoreAddressState, any, StoreAddress>{
    state = {
        totalCount: 0,
        total: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StoreAddress>(),
        loading: false,
        StoreAddresss: StoreAddress,
        id: 0,

    }
    actions = {
        async getAll(context: ActionContext<StoreAddressState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackStoreAddress/GetStoreAddressList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StoreAddress>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async Edit(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStoreAddress/EditStoreAddress', payload.data);
        },
        async Delete(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStoreAddress/Delete?id=' + payload.data.id);
            return rep.data.result;
        },
        async EditStatus(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStoreAddress/EditStatus?id=' + payload.data.id);
        },
    };
    mutations = {
        setCurrentPage(state: StoreAddressState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: StoreAddressState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const storeAddressinfos = new StoreAddressInfo();
export default storeAddressinfos;